module.exports = __webpack_public_path__ + "img/icon-warning.1c525326.svg";